import * as React from 'react';
const LineLoader: React.FC = (props) => (
  <svg
    height={21}
    width={'100%'}
    aria-labelledby='loading-aria'
    preserveAspectRatio='none'
    viewBox='0 0 400 160'
    {...props}
  >
    <title>{'Loading...'}</title>
    <rect
      width='100%'
      height='100%'
      clipPath='url(#a)'
      style={{
        fill: 'url(#b)',
      }}
    />
    <defs>
      <linearGradient id='b'>
        <stop offset={0.6} stopColor='#f3f3f3'>
          <animate
            attributeName='offset'
            dur='2s'
            keyTimes='0; 0.25; 1'
            repeatCount='indefinite'
            values='-2; -2; 1'
          />
        </stop>
        <stop offset={1.6} stopColor='#ecebeb'>
          <animate
            attributeName='offset'
            dur='2s'
            keyTimes='0; 0.25; 1'
            repeatCount='indefinite'
            values='-1; -1; 2'
          />
        </stop>
        <stop offset={2.6} stopColor='#f3f3f3'>
          <animate
            attributeName='offset'
            dur='2s'
            keyTimes='0; 0.25; 1'
            repeatCount='indefinite'
            values='0; 0; 3'
          />
        </stop>
      </linearGradient>
      <clipPath id='a'>
        <rect width='98%' height='100%' rx={35} ry={35} />
      </clipPath>
    </defs>
  </svg>
);
export default LineLoader;
